// @flow

export function handleError(error: any) {
  getHandlerImpl()(error);
}

type HandlerErrorImpl = (error: any) => void;

function getHandlerImpl(): HandlerErrorImpl {
  if (ENV_CONSTANTS.ENV !== 'production' || !window.Rollbar)
    return consoleErrorHandler;

  return rollbarErrorHandler;
}

function consoleErrorHandler(error: any) {
  /* eslint-disable-next-line */
  console.error(error);
}

function rollbarErrorHandler(error: any) {
  window.Rollbar.log(error.stack || 'stack is empty');
  window.Rollbar.error(error);
}
